import React from 'react';
import { motion } from 'framer-motion';
import { FileText, List, CheckCircle2 } from 'lucide-react';
export function ContentPreview() {
  return <section className="py-24 bg-white" data-id="element-266">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-267">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-268">
          <h2 className="text-3xl md:text-4xl font-bold text-ink mb-4 tracking-tight" data-id="element-269">
            Un vistazo por dentro
          </h2>
          <p className="text-lg text-ink-light" data-id="element-270">
            Material diseñado con los más altos estándares de calidad, pensado
            para facilitar tu día a día.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-271">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="relative" data-id="element-272">
            <div className="rounded-3xl overflow-hidden shadow-premium border border-ink/5" data-id="element-273">
              <img src="https://cdn.magicpatterns.com/uploads/xkJLkJLmuTkxdZ4bHwdvZN/ChatGPT_Image_2_jul_2026,_02_45_12_p.m..png" alt="Vista previa del contenido: recetas, índice, información nutricional, plan semanal y lista de compras" className="w-full h-auto object-cover" data-id="element-274" />
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="space-y-8" data-id="element-275">
            <div className="bg-cream p-8 rounded-[2rem] border border-ink/5" data-id="element-276">
              <div className="w-12 h-12 rounded-full bg-white flex items-center justify-center mb-6 shadow-sm" data-id="element-277">
                <FileText className="w-6 h-6 text-combo-green" data-id="element-278" />
              </div>
              <h3 className="text-xl font-bold text-ink mb-3" data-id="element-279">
                Diseño claro y minimalista
              </h3>
              <p className="text-ink-light" data-id="element-280">
                Cada receta está presentada de forma limpia, con instrucciones
                paso a paso fáciles de seguir, tiempos de preparación y
                porciones exactas.
              </p>
            </div>

            <div className="bg-cream p-8 rounded-[2rem] border border-ink/5" data-id="element-281">
              <div className="w-12 h-12 rounded-full bg-white flex items-center justify-center mb-6 shadow-sm" data-id="element-282">
                <List className="w-6 h-6 text-combo-green" data-id="element-283" />
              </div>
              <h3 className="text-xl font-bold text-ink mb-3" data-id="element-284">
                Listas de compras interactivas
              </h3>
              <p className="text-ink-light" data-id="element-285">
                Organizá tu visita al supermercado con listas detalladas por
                categorías para que no te olvides de nada y ahorres tiempo.
              </p>
            </div>

            <div className="bg-cream p-8 rounded-[2rem] border border-ink/5" data-id="element-286">
              <div className="w-12 h-12 rounded-full bg-white flex items-center justify-center mb-6 shadow-sm" data-id="element-287">
                <CheckCircle2 className="w-6 h-6 text-combo-green" data-id="element-288" />
              </div>
              <h3 className="text-xl font-bold text-ink mb-3" data-id="element-289">
                Información nutricional
              </h3>
              <p className="text-ink-light" data-id="element-290">
                Conocé exactamente qué estás comiendo. Cada receta incluye
                macronutrientes detallados para ayudarte a cumplir tus
                objetivos.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}